import { render, staticRenderFns } from "./UrunList.vue?vue&type=template&id=749527b9&scoped=true"
import script from "./UrunList.vue?vue&type=script&lang=js"
export * from "./UrunList.vue?vue&type=script&lang=js"
import style0 from "./UrunList.vue?vue&type=style&index=0&id=749527b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749527b9",
  null
  
)

export default component.exports